// extracted by mini-css-extract-plugin
export default {"labelMap":"home_labelMap__nBr9K"};